import { CircleCheck } from "lucide-react";

// =============================================================================
// AddressConfirmedHint
//
// Quiet positive state shown under an address field once it carries map
// coordinates (picked from the Google dropdown, a curated Mount Sinai
// location, or a saved address). It communicates a STATE — "locked to a real
// map location, will dispatch correctly" — without echoing the city/ZIP that
// is already visible in the field. The amber AddressPickHint is its mutually
// exclusive counterpart for addresses that have no coordinates yet.
// =============================================================================

export function AddressConfirmedHint() {
  return (
    <p
      role="status"
      className="flex items-center gap-1.5 text-xs font-medium text-success"
    >
      <CircleCheck className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
      <span>Location confirmed</span>
    </p>
  );
}
